export default __webpack_public_path__ + "static/media/irene.9b68fd31.jpeg";